import React from 'react';
import PropTypes from 'prop-types';
import { AppointmentTooltip } from '@devexpress/dx-react-scheduler-material-ui';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
	root: {
        color: 'red',
        '& :nth-child(1)': {
             order: 2
        },
        '& :nth-child(2)': {
             order: 3
        },
        '& :nth-child(3)': {
             order: 1
        }
    },
    iconButtonLabel: {
        display: 'flex',
        flexDirection: 'column'
    }
});

const Header = (props) => {
    const { root } = useStyles();
    const { defaultProps, isDoctor } = props;

    return (
        <AppointmentTooltip.Header
            {...defaultProps}
            showDeleteButton={isDoctor === false}
            showOpenButton={isDoctor === false}
            className={root}
        >
        </AppointmentTooltip.Header>
    )
}

Header.propTypes = {
    defaultProps: PropTypes.object,
    isDoctor: PropTypes.bool
}

export default Header;
